import { useState } from 'react';

import { useAppSelector } from '@shared/hooks/redux';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';

import { ProductVariantType } from '../model/types/productCard';
import { getProductUrl } from '../utils/getProductUrl';

export const useProductVariant = (data: ProductVariantType['data']) => {
  const viewPort = useAppSelector(getViewPort);
  const [hover, setHover] = useState(false);
  const url = getProductUrl(data.id, data.url);

  const mouseOnHaler = () => {
    if (viewPort !== 'desktop') return;
    setHover(true);
  };

  const mouseLeaveHandler = () => {
    if (viewPort !== 'desktop') return;
    setHover(false);
  };

  return {
    hover,
    url,
    mouseOnHaler,
    mouseLeaveHandler
  };
};
